import { createActionType, createApiActionType } from 'app/store/utils';

const type = createActionType('projectHistory');
const apiType = createApiActionType('projectHistory');

export const LIST_PROJECT_HISTORY_ACTION = apiType('ListProjectHistory');
export const LIST_VIEW_HISTORY_ACTION = apiType('ListViewHistory');

export const TOGGLE_DIALOG = type('ToggleDialog');
